// ─────────────────────────────────────────────────────────────────────────────
// MerchantRow — merchant identity + payer identity-echo.
//
// Left side:  avatar (derived from merchantDisplayName initials) + name
// Right side: masked payer email (currently mock; backend field TBD —
//             see carry-forward note below)
//
// Props:
//   merchantDisplayName — from BFF. Defaulted server-side to 'Posteering'
//     when creator omits it. Always a non-empty string.
//
// Carry-forward for future session:
//   The payer-email shown here is STATIC MOCK DATA. The BFF's
//   PublicCheckoutResponse currently has no payerEmail / payerPhone
//   fields. When those fields are added to payment_intents and exposed
//   through the BFF allow-list, this component grows props and hides
//   the row element cleanly when data is missing. Logged in handoff.
// ─────────────────────────────────────────────────────────────────────────────

export interface MerchantRowProps {
  merchantDisplayName: string;
}

export function MerchantRow({ merchantDisplayName }: MerchantRowProps) {
  const initials = getInitials(merchantDisplayName);

  return (
    <div className="merchant-row">
      <div className="merchant">
        <span className="merchant-avatar" aria-hidden="true">
          {initials}
        </span>
        <span className="merchant-name">{merchantDisplayName}</span>
      </div>
      {/* Static until BFF exposes payerEmail — see file header note */}
      <span className="payer-email">ad***ri@gmail.com</span>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Derive a 2-letter avatar from a merchant name.
//
//   "Adebayo Plumbing Services"  → "AP"
//   "Posteering"                 → "PO"
//   "C"                          → "C"
//   ""                           → "?"   (defensive; shouldn't happen)
//
// Rules:
//   - Take the first letter of the first TWO whitespace-separated words
//   - If only one word, take its first two characters
//   - Uppercase everything
//   - Fall back to "?" for an empty/whitespace-only string
// ─────────────────────────────────────────────────────────────────────────────

function getInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '?';

  const words = trimmed.split(/\s+/);
  if (words.length >= 2) {
    const first = words[0] ?? '';
    const second = words[1] ?? '';
    return ((first[0] ?? '') + (second[0] ?? '')).toUpperCase();
  }

  const sole = words[0] ?? '';
  return sole.slice(0, 2).toUpperCase();
}
